// Stil dosyasını import et
import '../css/app.css';

// React ve temel bileşenleri import et
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Firebase ve API yapılandırmasını import et
import './services/firebase';
import api from './bootstrap';

// Ana uygulama bileşenini import et
import App from './App';

// API'yi global olarak tanımla
window.api = api;

// DOMContentLoaded event'ini bekle
document.addEventListener('DOMContentLoaded', () => {
    // Root elementi bul
    const container = document.getElementById('app');

    if (container) {
        try {
            // React uygulamasını başlat
            const root = createRoot(container);
            root.render(
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            );
            
            // Geliştirme modunda log mesajlarını göster
            if (import.meta.env.MODE === 'development') {
                console.log('React uygulaması başarıyla başlatıldı');
            }
        } catch (error) {
            console.error('React uygulaması başlatılırken hata oluştu:', error);
        }
    } else {
        console.error('Root element (id="app") bulunamadı!');
        if (import.meta.env.MODE === 'development') {
            console.log('Mevcut HTML:', document.documentElement.innerHTML);
        }
    }
});
